import { Banner, Link } from '@customerio/pluma-components/react';
import { STARTUP_PROGRAM_URL } from '@/constants/startup-program';
import * as styles from './signup-startup-program-banner.css';

type SignupStartupProgramBannerProps = {
  /** Swaps in the dark-mode fill; Pluma's own would outshout the form. */
  isDark: boolean;
  onStartHereClick: () => void;
};

/**
 * Points Startup Program applicants at the product page before they create a
 * regular free account, which has no migration path to Startup.
 */
export function SignupStartupProgramBanner({ isDark, onStartHereClick }: SignupStartupProgramBannerProps) {
  return (
    <Banner
      variant="information"
      className={isDark ? styles.darkFill : undefined}
      description={
        <>
          Applying for Startup Program?{' '}
          {/* Underlined because the banner's own text is already emphasized —
              without it the link reads as bold copy rather than the way out. */}
          <Link href={STARTUP_PROGRAM_URL} isExternal isUnderlined onClick={onStartHereClick}>
            Start here
          </Link>
          .
        </>
      }
      data-test-signup-startup-program-banner
    />
  );
}
